import { render, staticRenderFns } from "./LoyaltiyRewardSettings.vue?vue&type=template&id=2f2a7e2e&scoped=true"
import script from "./LoyaltiyRewardSettings.vue?vue&type=script&lang=js"
export * from "./LoyaltiyRewardSettings.vue?vue&type=script&lang=js"
import style0 from "./LoyaltiyRewardSettings.vue?vue&type=style&index=0&id=2f2a7e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2a7e2e",
  null
  
)

export default component.exports